export default __webpack_public_path__ + "map/map-style-2019.json";